import {
  Box,
  Button,
  Checkbox,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  VStack,
} from "@chakra-ui/react";
import { constant } from "common/constant";
import CommonCheckTable from "./checktable";
import editIcon from "common/assets/img/editIcon.png";
import DeleteIcon from "common/assets/img/deleteIcon.png";
import { crmConstant } from "services/Crm/constant";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { getApi } from "common/services/api";
import DateFormatter from "common/utils/dateFormater";


const RecipientsModal = ({ isOpen, onClose, onSave, initialData = {}, moduleFields = null }) => {
  const [owner, setOwner] = useState(false);
  const [manager, setManager] = useState(false);
  const [fromData, setFromData] = useState("");
  const [customEmails, setCustomField] = useState([]);

  const emailFields = moduleFields?.filter(
    (field) =>
      field?.type?.toLowerCase() === "email" ||
      field?.name?.toLowerCase().includes("email")
  ) || [];

  useEffect(() => {
    if (isOpen && initialData) {
      setOwner(initialData?.owner || false);
      setManager(initialData?.manager || false);
      setFromData(initialData?.fromData || "");
      setCustomField(Array.isArray(initialData?.customEmails) ? initialData.customEmails : []);
    }
  }, [isOpen, initialData]);

  useEffect(() => {
    if (!isOpen) {
      setOwner(false);
      setManager(false);
      setFromData("");
      setCustomField([]);
    }
  }, [isOpen]);

  const handleSave = () => {
    const data = {
      owner,
      manager,
      fromData,
      customEmails,
    };
    onSave(data);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Send Email</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack align="start" spacing={4}>
            <Checkbox
              isChecked={owner}
              onChange={() => {
                setOwner(!owner);
              }}
            >
              Owner
            </Checkbox>
            <Checkbox
              isChecked={manager}
              onChange={() => {
                setManager(!manager);
              }}
            >
              Manager
            </Checkbox>

            <Select
              placeholder="Select from data"
              value={fromData}
              onChange={(e) => setFromData(e.target.value)}
            >
              {emailFields.map((field) => (
                <option key={field.name} value={field.name}>
                  {field.label || field.name}
                </option>
              ))}
            </Select>

            <Input
              placeholder="Enter custom emails (comma separated)"
              value={customEmails.join(", ")} // Display array as comma-separated string
              onChange={(e) => {
                const input = e.target.value;
                const emailArray = input
                  .split(",")
                  .map((email) => email.trim())
                  .filter((email) => email.length > 0);
                setCustomField(emailArray);
              }}
            />
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose} variant="ghost">Cancel</Button>
          <Button
            colorScheme="blue"
            onClick={handleSave}
            isDisabled={!owner && !manager && customEmails.length === 0}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};


const DymanicTableModal = ({
  isTableModalOpen,
  onTableModalClose,
  handleNewEmailNotification,
  dataFromParent,
  moduleFields = null,
  metadata = {},
  onSubmitSelections,
  currentPage = 1,
  pageSize = 10,
  setCurrentPage = () => { },
  handleSortChange = () => { },
  handleSearchChange = () => { },
  setPageSize = () => { },
  editModeData = null 
}) => {
  const title = "Email Template List";
  const [getTagValuesOutSide, setGetTagValuesOutside] = useState([]);
  const [deleteMany, setDelete] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const [searchbox, setSearchbox] = useState(null);
  const [data, setData] = useState(dataFromParent || []);
  const [isOpen, setIsOpen] = useState(false);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("");
  const [action, setAction] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [recipientError, setRecipientError] = useState(false);

  const [isRecipientsModalOpen, setIsRecipientsModalOpen] = useState(false);
  const [recipientConfigRow, setRecipientConfigRow] = useState(null);

  useEffect(() => {
    let updatedData = [...(dataFromParent || [])];

    if (editModeData && editModeData.templateId) {

      updatedData = updatedData.map(template => {
        const templateId = typeof editModeData.templateId === 'object'
          ? editModeData.templateId._id
          : editModeData.templateId;

        if (template._id === templateId) {
          return {
            ...template,
            recipientsData: {
              owner: editModeData.recipients?.owners || false,
              manager: editModeData.recipients?.managers || false,
              fromData: editModeData.recipients?.from || [],
              customEmails: editModeData.recipients?.customEmails || []
            }
          };
        }
        return template;
      });

      const templateId = typeof editModeData.templateId === 'object'
        ? editModeData.templateId._id
        : editModeData.templateId;
      setSelectedValues([templateId]);
    }

    setData(updatedData);
  }, [dataFromParent, editModeData]);

  const handleRecipientsClick = (rowId) => {
    setRecipientConfigRow(rowId);
    setIsRecipientsModalOpen(true);
  };

  const handleRecipientSave = (configData) => {
    const updated = data.map((row) =>
      row._id === recipientConfigRow
        ? { ...row, recipientsData: { ...row.recipientsData, ...configData } }
        : row
    );
    setData(updated);
  };

  const tableColumns = [
    {
      Header: "#",
      accessor: "_id",
      isSortable: false,
      width: 10,
    },
    {
      Header: "Name",
      accessor: "name",
      cell: (cell) => (
        <Text
          me="10px"
          color="brand.600"
          sx={{
            "&:hover": {
              color: "blue.500",
              textDecoration: "underline",
              cursor: "pointer",
            },
          }}
          fontSize="sm"
          fontWeight="700"
        >
          {cell?.value}
        </Text>
      ),
    },
    {
      Header: "Email template",
      accessor: "module",
      cell: ({ value }) => (
        <Text textTransform="capitalize">{value || "-"}</Text>
      ),
    },
    {
      Header: "Modified on",
      accessor: "updatedAt",
      cell: ({ value }) => (
        <Text textTransform="capitalize">{DateFormatter(value) || "-"}</Text>
      ),
    },
    {
      Header: "Send To",
      accessor: "recipientsData",
      cell: ({ row }) => {
        const recipient = row.original.recipientsData;
        const label = recipient
          ? [
            recipient.owner ? "Owner" : "",
            recipient.manager ? "Manager" : "",
          ]
            .filter(Boolean)
            .join(", ")
          : "Recipients";

        return (
          <Text
            color="blue.500"
            textDecor="underline"
            cursor="pointer"
            onClick={() => handleRecipientsClick(row.original._id)}
          >
            {label}
          </Text>
        );
      },
    }
  ];

  const [selectedColumns, setSelectedColumns] = useState([...tableColumns]);

  const permission = user?.permissions || {
    create: true,
    edit: true,
    delete: true,
    view: true,
  };

  const onOpen = () => {
    setIsOpen(true);
  };

  const handleAssociate = () => {
    const selectedRows = data.filter((row) => selectedValues.includes(row._id));

    const hasMissingRecipients = selectedRows.some(
      (row) =>
        !row.recipientsData || (!row.recipientsData.owner && !row.recipientsData.manager && !row.recipientsData.customEmails?.length)
    );

    if (hasMissingRecipients) {
      setRecipientError(true);
      return;
    }

    setRecipientError(false);
    onSubmitSelections?.(selectedRows);
    onTableModalClose();
  };

  return (
    <>
      <Modal isOpen={isTableModalOpen} onClose={onTableModalClose} isCentered>
        <ModalOverlay />
        <ModalContent maxW={"790px"} width={"100%"} zIndex={"999999"} className="workflowNotificationModal">
          <ModalHeader>{constant.emailNotification}</ModalHeader>
          <ModalCloseButton />
          <ModalBody className="modalBody">
            <CommonCheckTable
              title={title}
              isLoading={isLoading}
              columnData={tableColumns}
              dataColumn={tableColumns}
              allData={data}
              checkBox={true}
              access={permission}
              action={action}
              setAction={setAction}
              setDelete={setDelete}
              BackButton={
                <Button
                  className="shape-default"
                  onClick={() => navigate("/admin-setting")}
                  variant="brand"
                  size="sm"
                  leftIcon={<IoIosArrowBack />}
                >
                  Back
                </Button>
              }
              getTagValuesOutSide={getTagValuesOutSide}
              setGetTagValuesOutside={setGetTagValuesOutside}
              ManageGrid={false}
              onOpen={onOpen}
              tableData={data}
              tableCustomFields={[]}
              deleteMany={false}
              selectedValues={selectedValues}
              setSelectedValues={setSelectedValues}
              selectedColumns={selectedColumns}
              setSelectedColumns={setSelectedColumns}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              fetchData={data}
              pageSize={pageSize}
              setPageSize={setPageSize}
              metadata={metadata}
              sortOrder={sortOrder}
              handleSortChange={handleSortChange}
              handleSearchChange={handleSearchChange}
              searchbox={searchbox}
              setSearchbox={setSearchbox}
              isHideNavbarAction={false}
              isShowEmailBtn={true}
              handleNewEmailNotification={handleNewEmailNotification}
            />
          </ModalBody>
          <ModalFooter>
            {recipientError && (
              <Text color="red.500" fontSize="sm" mr={4}>
                Please select recipients for  selected rows.
              </Text>
            )}
            <Button
              variant="outline"
              colorScheme="red"
              size="sm"
              sx={{ marginRight: 4, textTransform: "capitalize" }}
              onClick={onTableModalClose}
              className="theme-btn2 cancelBtn"
            >
              {constant.cancel}
            </Button>
            <Button variant={"brand"} className="theme-btn1" onClick={handleAssociate}
              isDisabled={selectedValues.length === 0}>
              {constant.associate}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <RecipientsModal
        isOpen={isRecipientsModalOpen}
        onClose={() => setIsRecipientsModalOpen(false)}
        onSave={handleRecipientSave}
        initialData={
          data.find((item) => item._id === recipientConfigRow)?.recipientsData
        }
        moduleFields={moduleFields}
      />

    </>
  );
};
export default DymanicTableModal;
